<template>
  <div>
    <v-btn fab style="border: white 4px solid;" color="green" dark fixed bottom right x-large @click="toWhatsapp()">
      <v-icon>mdi-whatsapp</v-icon>
    </v-btn>
    <audio id="miAudio" src="@/assets/default/sonido.mp3"></audio>
    <menus :propDialog="dialogMenu" @closeDialog="dialogMenu = false" />
    <popup :propDialogo="dialogoPopup" @cerrarDialogo="dialogoPopup = false"
      @activarPopupDialogo="dialogoPopup = true" />
    <v-toolbar class="pl-10 pr-10" :style="{ backgroundColor: $ajustes.colorCabecera }"
      style="width: 100%; position: fixed; z-index: 99;" flat>
      <div class="flex" style="vertical-align: middle; height: 100%;">
        <v-icon @click="dialogMenu = true" large :style="{ color: $ajustes.colorTextoLogo }">mdi-menu</v-icon>
        <h1 v-if="false" style="font-size: xx-large; padding: 2px; padding-left: 10px;" :style="{ color: $ajustes.colorTextoLogo }">
          {{
            this.$appInfo.textoLogoCorto }}</h1>
        <img height="100%" class="ml-3" contain :src="$appInfo.icon2"/>
      </div>
      <div class="mt-2" v-if="!$vuetify.breakpoint.smAndDown">
          <v-btn :style="{ color: $ajustes.colorTexto1 }" icon :href="$ajustes.linkFacebook" target="_blank"
            class="white--text">
            <v-icon>mdi-facebook</v-icon>
          </v-btn>
          <v-btn :style="{ color: $ajustes.colorTexto1 }" dark icon :href="$ajustes.linkInstagram" target="_blank"
            class="white--text">
            <v-icon>mdi-instagram</v-icon>
          </v-btn>
          <v-btn :style="{ color: $ajustes.colorTexto1 }" dark icon :href="'mailto:' + $ajustes.linkEmail"
            class="white--text">
            <v-icon>mdi-email</v-icon>
          </v-btn>
        </div>
      <v-spacer></v-spacer>
      <v-icon v-if="!$vuetify.breakpoint.smAndDown" @click="irAInicio" :style="{ color: $ajustes.colorTexto1 }">
        mdi-home
      </v-icon>
      <h2 v-if="!$vuetify.breakpoint.smAndDown" class="pa-2 pointer" :style="{ color: $ajustes.colorTexto1 }"
        @click="$router.push({ name: 'Cursos' })">Oferta Academica</h2>
      <h2 v-if="false" class="pa-2 pointer" :style="{ color: $ajustes.colorTexto1 }"
        @click="$router.push({ name: 'Cursos' })">Matriculate</h2>
    </v-toolbar>
  </div>
</template>

<script>
import menus from "@/components/dialog/menu";
import popup from "@/components/dialog/popup";

export default {
  components: {
    menus,
    popup
  },
  props: {
    propIdPc: { type: String },
  },
  data() {
    return {
      dialogMenu: false,
      dialogoPopup: false,
    };
  },
  methods: {
    toWhatsapp() {
      const numero = this.$appInfo.celular; // Número sin + ni espacios
      const mensaje = "Hola, quiero más información sobre INSEG";
      // Para URL encodear el mensaje (espacios, tildes, etc.)
      const mensajeEncoded = encodeURIComponent(mensaje);

      // Armar el link completo
      const whatsappLink = `https://wa.me/${numero}?text=${mensajeEncoded}`;
      window.open(whatsappLink, '_blank');
    },
    handleUserClickOnce() {
      if (this.$ajustes.audio == 1) {
        const audio = document.getElementById('miAudio');
        if (audio) {
          audio.volume = 0.02;

          audio.play().then(() => {
            // Detener audio después de 30 segundos (30,000 milisegundos)
            setTimeout(() => {
              audio.pause();
              audio.currentTime = 0; // Reinicia el audio al inicio
            }, 20000);
          }).catch((err) => {
            console.warn("No se pudo reproducir el audio:", err);
          });
        }
      }
    },
    irAInicio() {
      if (this.$route.name === 'Inicio') {
        this.$router.go(0); // Recarga la página (full refresh)
      } else {
        this.$router.push({ name: 'Inicio' });
      }
    },
    closeDialogRemote() {
    }
  },
  mounted() {
    // Agregar un manejador de eventos de clic al documento
    document.addEventListener("click", this.handleUserClickOnce, { once: true });
    document.addEventListener("click", this.handleClickOutside);
    if (this.$ajustes.audio == 1) {
      const audio = document.getElementById('miAudio');
      audio.volume = 0.2;     // ✅ volumen al 20%
      audio.loop = true;
      audio.play();
    }
  },
  beforeDestroy() {
    // Eliminar el manejador de eventos de clic al destruir el componente
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style>
* {
  padding: 0%;
  margin: 0%;
}

.navbar {
  display: flex;
  border-bottom: 0.1px solid #00000013;
}

.iconUser {
  cursor: pointer;
  float: right;
  margin-right: 10px;
  margin-top: 5px;
}

.divSearch {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 0.1px solid #00000013;
  border-radius: 90px;
  overflow: hidden;
}

.inputSearch {
  height: 100%;
  padding-right: 20px;
  font-size: large;
  outline: none;
}

.iconErase {
  height: 100%;
  margin: 0px 10px 0px 5px;
  cursor: pointer;
}

.iconSearch {
  height: 100%;
  margin: 0px 10px 0px 5px;
  cursor: pointer;
}
</style>
